// shared/MarketplaceFooter.jsx
import React from "react";
import { Link } from "react-router-dom";
import { brand, WA_HREF } from "./brand";

export function MarketplaceFooter() {
  return (
    <footer className="border-t border-slate-100 bg-white mt-auto">
      <div className="mx-auto max-w-7xl px-4 py-10 grid gap-8 md:grid-cols-4">

        {/* Brand */}
        <div className="col-span-2">
          <Link to="/" className="flex items-center gap-2 mb-3">
            <img
              src={`${process.env.PUBLIC_URL}/logo.png`}
              alt="FAST MAX"
              className="h-7 w-auto"
            />
            <span
              className="text-base font-extrabold italic tracking-wide"
              style={{ color: brand.primary }}
            >
              FAST MAX
            </span>
          </Link>
          <p className="text-sm text-slate-500 max-w-sm leading-relaxed">
            Plataforma logística para vendedores online en Lima. Entregas el mismo
            día con seguimiento en vivo y cobro contraentrega.
          </p>
        </div>

        {/* Plataforma links */}
        <div>
          <h4 className="text-xs font-bold text-slate-700 uppercase tracking-wide mb-3">
            Plataforma
          </h4>
          <ul className="space-y-2 text-sm text-slate-500">
            <li><Link to="/tienda#beneficios" className="hover:text-slate-800 transition-colors">Beneficios</Link></li>
            <li><Link to="/tienda#proceso"    className="hover:text-slate-800 transition-colors">Cómo funciona</Link></li>
            <li><Link to="/tienda#referidos"  className="hover:text-slate-800 transition-colors">Programa de referidos</Link></li>
            <li><Link to="/tienda#tecnologia" className="hover:text-slate-800 transition-colors">Tecnología</Link></li>
            <li><Link to="/tienda#cobertura"  className="hover:text-slate-800 transition-colors">Cobertura</Link></li>
            <li><Link to="/tienda#precios"    className="hover:text-slate-800 transition-colors">Precios</Link></li>
          </ul>
        </div>

        {/* Contacto */}
        <div>
          <h4 className="text-xs font-bold text-slate-700 uppercase tracking-wide mb-3">
            Contacto
          </h4>
          <ul className="space-y-2 text-sm text-slate-500">
            <li>contacto@fastmax.pe</li>
            <li>
              <a
                href={WA_HREF}
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-green-600 hover:underline"
              >
                WhatsApp: +51 977 689 676
              </a>
            </li>
            <li>Los Mirtos 145, Lima, Perú</li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-slate-100 py-4">
        <div className="mx-auto max-w-7xl px-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-400">
          <p>© {new Date().getFullYear()} FAST MAX. Todos los derechos reservados.</p>
          <div className="flex gap-4">
            <Link to="/terms"   className="hover:text-slate-600 transition-colors">Términos</Link>
            <Link to="/privacy" className="hover:text-slate-600 transition-colors">Privacidad</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}